
import { THEME_COLORS } from "./ThemeColorDefinition";

export const SHADOWS = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 18px 50px rgba(0, 0, 0, 0.10)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
} as const;

export const BORDERS = {
  none: "none",
  thin: "1px solid",
  thick: "2px solid",
  
  light: `1px solid ${THEME_COLORS.greyLight}`,
  medium: `1px solid ${THEME_COLORS.greyMedium}`,
  dark: `1px solid ${THEME_COLORS.primary}`,
  lightOverlay: `1px solid rgba(0,0,0,0.08)`,
} as const;

export const BORDER_RADIUS = {
  none: "0px",
  sm: "2px",
  base: "4px",
  md: "6px",
  lg: "8px",
  xl: "12px",
  "2xl": "16px",
  full: "9999px",
} as const;

export const ELEVATION_STYLES = {
  level1: {
    backgroundColor: "white",
    border: BORDERS.light,
    boxShadow: SHADOWS.sm,
  },
  
  level2: {
    backgroundColor: "white",
    border: BORDERS.light,
    boxShadow: SHADOWS.base,
  },
  
  level3: {
    backgroundColor: "white",
    border: BORDERS.light,
    boxShadow: SHADOWS.md,
  },
  
  card: {
    backgroundColor: "white",
    border: BORDERS.light,
    boxShadow: SHADOWS.base,
    borderRadius: BORDER_RADIUS.md,
  },
  
  modal: {
    backgroundColor: "white",
    border: BORDERS.light,
    boxShadow: SHADOWS.xl,
  },
} as const;

export const BUTTON_BORDER_STYLES = {
  bottomOnly: {
    border: "none",
    borderBottom: BORDERS.thin + " " + THEME_COLORS.secondary,
  },
  
  withShadow: {
    border: BORDERS.light,
    boxShadow: SHADOWS.sm,
  },
} as const;

export type Shadow = typeof SHADOWS;
export type Border = typeof BORDERS;














